import InputTypesEnum from "../../Enums/InputTypesEnum";
import dateTimeHelper from "../../Helpers/datetimeHelper";
import selectHelper from "../../Helpers/selectHelper";
import SearchParamsBase from "../../Elements/SearchParamsBase";

class ReportingFilterSearchParams extends SearchParamsBase
{
	initialize()
	{
		this.UseActualMonth=true;
		this.StartDate=dateTimeHelper.firstDayOfTheActualMonth();
		this.EndDate=dateTimeHelper.lastDayOfTheActualMonth();
		this.Created=false;
		this.ClientConfirmed=true;
		this.OnHold=true;
		this.Closed=false;
		this.Cancelled=false;

		this.Status=['ClientConfirmed','OnHold'];

		this.SelectedOfficeIds=[];
		this.ClientId="";
		this.ServiceId="";
		this.CountryId="";
		this.AccountManagerId="";
	}

	static defaultOfficeName="";

	static fieldsInSearchBox = [

		{ fieldName: "UseActualMonth", label: "Use Actual Month", className: "col-3", type: InputTypesEnum.OnOff },
		{ fieldName: "StartDate", label: "Start Date", className: "col-3", type: InputTypesEnum.Date, showCondition: (searchItem) => !searchItem.UseActualMonth },
		{ fieldName: "EndDate", label: "End Date", className: "col-3", type: InputTypesEnum.Date, showCondition: (searchItem) => !searchItem.UseActualMonth },
		{ fieldName: "Status", label: "Status", className: "col-3", type: InputTypesEnum.MultiChoice, options: ReportingFilterSearchParams.getStatusesFunction() },
		{ fieldName: "SelectedClientIds", label: "Client", className: "col-6", type: InputTypesEnum.ClientMultiChoice },
	];
	
	static iconName = "fa-solid fa-mug-hot";
	static saveType = "ReportingFilterSearchParams";
	static startSearchButtonLabel="View Report On Screen";
	static startSearchButtonIconName="fa-solid fa-mug-hot";

	static getStatusesFunction() {
		return selectHelper.generateSelectValues(["Created", "ClientConfirmed", "OnHold", "Closed", "Cancelled"]);
	}

}

export default ReportingFilterSearchParams;
